"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Box_1 = require("./Box");
const DocumentIcon = (props) => {
    const svgStyle = Object.assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" });
    return (React.createElement(Box_1.Box, Object.assign({ position: "relative", width: 18, height: 18 }, props),
        React.createElement("svg", { viewBox: "0 0 18 18", style: svgStyle, fill: "currentColor" },
            React.createElement("g", { clipPath: "url(#a)" },
                React.createElement("path", { d: "M14 2H4V16H14V2ZM15 1.5V16.5C15 16.6326 14.9473 16.7598 14.8536 16.8536C14.7598 16.9473 14.6326 17 14.5 17H3.5C3.36739 17 3.24021 16.9473 3.14645 16.8536C3.05268 16.7598 3 16.6326 3 16.5V1.5C3 1.36739 3.05268 1.24021 3.14645 1.14645C3.24021 1.05268 3.36739 1 3.5 1H14.5C14.6326 1 14.7598 1.05268 14.8536 1.14645C14.9473 1.24021 15 1.36739 15 1.5ZM6 10H12V11H6V10ZM6 13H10V14H6V13Z" })),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "a" },
                    React.createElement("rect", { width: 18, height: 18 }))))));
};
DocumentIcon.displayName = 'DocumentIcon';
exports.default = DocumentIcon;
//# sourceMappingURL=DocumentIcon.js.map